<template>
    <div>
        <div v-if="period">
            <div class="px-3 py-4">
                <h2 class="headline mb-3">
                    Faktura sendt {{ periodString }}
                </h2>

                <v-layout class="flex" align-center>
                    <div>
                        <v-select solo class="mt-0 mr-3" label="Fakturering" :items="invoiceIntervalItems"
                                  v-model="interval" hide-details style="max-width: 200px"/>
                    </div>
                    <div>
                        <v-btn large color="primary" class="mr-2" @click="go(-1)">
                            <v-icon left>arrow_left</v-icon>
                            Forrige periode
                        </v-btn>
                        <v-btn large color="primary" @click="go(1)">
                            Neste periode
                            <v-icon right>arrow_right</v-icon>
                        </v-btn>
                    </div>
                </v-layout>
            </div>
        </div>

        <v-data-table :headers="headers" :items="cars" class="elevation-1 car-table" :loading="loading"
                      :no-data-text="loading ? 'Laster...' : 'Ingen data funnet.'" hide-default-footer
                      no-results-text="Ingen resultater funnet."
                      :items-per-page="9999">
            <template v-slot:item="{ item }">
                <InvoicingRow :value="item"/>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import moment from 'moment';
import InvoicingRow from "../helpers/InvoicingRow";
import {invoiceIntervalItems} from '../../helpers';

export default {
    components: {
        InvoicingRow
    },
    data() {
        return {
            loading: false,
            period: null,
            cars: []
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        go(delta) {
            this.date = moment(this.date).add(delta * this.interval, 'months').format('YYYY-MM-DD');
        },
        loadData() {
            this.cars = [];
            this.loading = true;
            let params = {
                interval: this.interval,
                date: this.date
            }

            let fourMonthsAfter = moment(this.date).add(4, 'months').format('YYYY-MM-DD');
            this.$http.get(`invoicing`, {params}).then(response => {
                let cars = response.data.data;
                cars.forEach(car => {
                    car.has_customer_number = !!car.customer_number;
                    car.previous_date = car.date;
                    if(car.previous_date < fourMonthsAfter) {
                        car.date = null;
                        car.invoice_number = null;
                        car.id = null; // Car invoice ID. The Car's ID is car_id.
                    }
                })
                this.cars = cars;
                this.period = response.data.period;
            }).finally(() => {
                this.loading = false;
            });
        }
    },

    watch: {
        'date'() {
            this.loadData();
        },
        'interval'() {
            let newStartDate = moment().startOf('year').format('YYYY-MM-DD');
            let oldDate = this.date;
            this.date = newStartDate;
            if (oldDate === newStartDate) {
                this.loadData();
            }
        }
    },

    computed: {
        headers() {
            return [
                {text: 'Kundenr.', value: 'customer_number'},
                {text: 'Kundenavn', value: 'customer_name'},
                {text: 'Bil', value: 'reg_number'},
                {text: 'Dekk i perioden', value: 'types', sortable: false},
                {text: '', value: 'invoice_number', sortable: false, width: '125px'},
                {text: 'Fakturadato.', value: 'invoice_number', sortable: false},
                {text: 'Fakturanr.', value: 'invoice_number', sortable: false},
                {text: ' ', value: 'invoice_number', sortable: false}
            ];
        },

        periodString() {
            if (!this.period) return '';

            return `${moment(this.period.start).format('ll')} - ${moment(this.period.end).format('ll')}`
        },

        invoiceIntervalItems() {
            let values = [...invoiceIntervalItems];
            values[values.length - 1].value = -1;
            return values;
        },

        'interval': {
            get() {
                let interval = parseInt(this.$route.query['interval'], 10);
                return Number.isInteger(interval) ? interval : 12;
            },
            set(value) {
                this.$router.push({...this.$route, query: {...this.$route.query, interval: value}});
            }
        },
        'date': {
            get() {
                let date = this.$route.query['date'];
                if (date) return date;
                return moment().startOf('year').format('YYYY-MM-DD');
            },
            set(value) {
                this.$router.push({...this.$route, query: {...this.$route.query, date: value}});
            }
        }
    },
}
</script>

<style scoped>

</style>
